import { AfterViewChecked, Component, ElementRef, Inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { searchSecuritiesTableHeads } from '../../models/search-securities-table-header.model';
import { DefaultValues, emtrConstant } from '../../constants/emtrConstants';
import { CustomSortService, SharedConstant, SharedService, InstrumentGroupService, EmtrPagination, EmtrPaginationValues  } from '@ems/shared';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { RuleService } from '../../services/rule-service/rule.service';
import { Paginator } from 'primeng/paginator';

@Component({
  selector: 'tr-view-symbols-modal',
  templateUrl: './view-symbols-modal.component.html',
  styleUrls: ['./view-symbols-modal.component.scss']
})
export class ViewSymbolsModalComponent implements OnInit, AfterViewChecked, OnDestroy {

  @Input() loadModal = false;
  @ViewChild('p') paginator: Paginator;
  modalTitle = 'View Symbols';
  modalId: any;
  colHeader: any[];
  tickerSymbolData: any[] =[];
  getEmtrConstants = emtrConstant;
  totalRecords = 0;
  noOfRecords: any = DefaultValues.defaultTableRecords;
  businessUnit: any;
  orgId: any;
  getSharedConstant = SharedConstant;
  toggle = true;
  filterClicked = false;
  isClickedClearBtn = false;
  isSortingChanged = false;
  multiSortMeta: any = [];
  stateVal: any;
  defaultSortDataField = { field: 'updTs', order: -1 };
  sortClearButtonReset = false;
  initialLoad = false;
  paginationCount: any = 0;
  invalidCusip = false
  invalidSedol = false;
  invalidIsin = false;
  invalidName = false;
  invalidTickerSymbol = false;
  securityListFilterForm: FormGroup;
  pageObject: EmtrPagination = EmtrPaginationValues;
  customSortCSSRender: any;
  filtersApply: boolean;

  constructor(@Inject('commonConstants') public commonConstants, public instrumentGroupService: InstrumentGroupService,
    public sharedService: SharedService, public fb: FormBuilder, public messageService: MessageService, public ruleService: RuleService,
    public el: ElementRef, public customSortService: CustomSortService) {
    this.sharedService.clientInformation.subscribe(clientInfo => {
      this.businessUnit = clientInfo && clientInfo.businessUnit;
      this.orgId = clientInfo && clientInfo.orgId;
    });
  }

  ngOnInit() {
    this.colHeader = searchSecuritiesTableHeads;
    this.securityListFilterForm = this.fb.group({
      tickerSymbol: '',
      securityType: '',
      name: '',
      cusip: '',
      sedol: '',
      isin: ''
    });
    this.multiSortMeta = [{ ...this.defaultSortDataField }];
    this.getEmtrConstants.instrumentGroups.instrumentGrpStep3.securityTypeList
      .sort((a, b) => a.value.localeCompare(b.value))
      .map(item => item.value);
    setTimeout(() => {
      this.securityListFilterForm.patchValue({ securityType: this.getEmtrConstants.instrumentGroups.instrumentGrpStep3.securityTypeList });
    }, 10);
    this.securitiesListFormValidations();
    this.securityFilterNotifications();
  }
  ngAfterViewChecked(): void {
    const elementRef = this.el.nativeElement.querySelectorAll('.p-multiselect-label')[0];
    this.sharedService.setMultiSelectDefaultLabel(elementRef, this.securityListFilterForm, 'securityType', this.getEmtrConstants.instrumentGroups.instrumentGrpStep3.securityTypeList.length);
  }

  /*Open View Symbols Modal*/
  openModal(groupData) {
    this.toggle = true;
    this.modalTitle = 'Instrument Group' + ' - ' + groupData.name;
    this.modalId = groupData.id;
    this.getTickerSymbolsData(groupData);
    this.sharedService.openModal('view-symbol-modal');
    this.toggleFunction();
    this.resetForm();
  }

  /*Close View Symbols Modal*/
  closeViewSymbolModal() {
    this.noOfRecords = DefaultValues.defaultTableRecords;
    this.tickerSymbolData = [];
    this.filterClicked = false;
    this.paginationCount = 0;
    this.clickedClearButton(this.isSortingChanged);
  }

  getTickerSymbolsData(groupData) {
    this.instrumentGroupService.getSecurityGroupbyID(groupData.id, this.businessUnit, this.orgId).subscribe((instGrpData: any) => {
      this.getListOfSecurities();
      this.sharedService.tableDropdownVal.next(this.pageObject.pageSize);
    });
  }

  receiveDataFromChild(e) {
    this.noOfRecords = parseInt(e, 10);
    this.tickerSymbolData = [...this.tickerSymbolData];
  }
  toggleFunction() {
    this.toggle = !this.toggle;
  }
  securitiesListFormValidations() {
    /*  Select Securities filter value changes  */
    this.securityListFilterForm.get('tickerSymbol').valueChanges.subscribe(value => {
      this.invalidTickerSymbol = (value && this.securityListFilterForm.get('tickerSymbol').invalid)
      this.ruleService.invalidTickerSymbolField.emit(this.invalidTickerSymbol);
    });

    this.securityListFilterForm.get('name').valueChanges.subscribe(value => {
      this.invalidName = (value && value.length < 2);
      this.ruleService.invalidNameField.emit(this.invalidName);
    });

    this.securityListFilterForm.get('cusip').valueChanges.subscribe(value => {
      this.invalidCusip = this.sharedService.isValueLengthLessThan9(value);
      if (this.invalidCusip) {
        this.ruleService.invalidCusipSymbolFieldIG.emit(true);
      }
      else {
        this.ruleService.invalidCusipSymbolFieldIG.emit(false);
      }
      if (this.securityListFilterForm.get('cusip').invalid) {
        this.ruleService.specialCharValidationForCusip.emit(true);
      } else {
        this.ruleService.specialCharValidationForCusip.emit(false);
      }
    });

    this.securityListFilterForm.controls.sedol.valueChanges.subscribe(value => {
      this.invalidSedol = (value && value.length < 7)
      this.ruleService.invalidSedolField.emit(this.invalidSedol);
      if (this.securityListFilterForm.get('sedol').invalid) {
        this.ruleService.specialCharValidationForSedol.emit(true);
      } else {
        this.ruleService.specialCharValidationForSedol.emit(false);
      }
    });

    this.securityListFilterForm.controls.isin.valueChanges.subscribe(value => {
      this.invalidIsin = (value && value.length < 12)
      this.ruleService.invaliIsinField.emit(this.invalidIsin);
      if (this.securityListFilterForm.get('isin').invalid) {
        this.ruleService.specialCharValidationForIsin.emit(true);
      } else {
        this.ruleService.specialCharValidationForIsin.emit(false);
      }
    });
  }
  onInputChange(fieldName: string, event: any) {
    const value = event.target.value;
    const fieldListExceptActions = Object.keys(this.securityListFilterForm.controls).filter(field => field !== 'actions');
    const updatedFields = fieldListExceptActions.filter(field => field !== fieldName);
    if (value && value.trim().length > 0) {
      updatedFields.forEach(field => {
        if (field !== 'securityType') {
          this.securityListFilterForm.get(field).reset();
        } else {
          this.securityListFilterForm.patchValue({ securityType: this.getEmtrConstants.instrumentGroups.instrumentGrpStep3.securityTypeList });
        }

        this.securityListFilterForm.get(field).disable();
      });
    } else {
      fieldListExceptActions.forEach(field => {
        this.securityListFilterForm.get(field).enable();
      });
    }
  }
  applyFilter() {
    this.filterClicked = this.paginationCount > 1 ? true : false;
    this.filtersApply = true;
    this.pageObject.pageNo = 0;
    if (this.paginator) {
      this.paginator.changePage(0);
    }
    this.getListOfSecurities();
    this.tickerSymbolData = [...this.tickerSymbolData];
  }
  clickedClearButton(resetSortFromUI?) {
    this.resetForm(resetSortFromUI);
    this.sharedService.tableDropdownVal.next(this.pageObject.pageSize);
    if (!this.sortClearButtonReset) {
      this.getListOfSecurities();
    }
  }
  clearSuccessAndErrorMessages() {
    this.messageService.clear();
    this.sharedService.clearErrorMessage();
  }
  resetForm(resetSortFromUI?) {
    this.filterClicked = this.filtersApply = false;
    this.clearSuccessAndErrorMessages();
    const fieldListExceptActions = Object.keys(this.securityListFilterForm.controls).filter(field => field !== 'actions');
    fieldListExceptActions.forEach(field => {
      this.securityListFilterForm.get(field).enable();
    });
    this.securityListFilterForm.reset();
    this.securityListFilterForm.markAsPristine();
    if (resetSortFromUI) {
      this.multiSortMeta = [this.defaultSortDataField];
      this.sortClearButtonReset = true;
    }
    if (this.toggle) {
      this.isClickedClearBtn = true;
    }
    this.pageObject.pageNo = 0;
    if (this.paginator) {
      this.paginator.changePage(0);
    }
    this.securityListFilterForm.patchValue({ securityType: this.getEmtrConstants.instrumentGroups.instrumentGrpStep3.securityTypeList });
    this.filterClicked = this.isClickedClearBtn = false;
    this.securityListFilterForm.markAsPristine();
  }
  securityFilterNotifications() {
    const securityListFilterSubscriptions = [
      { value: this.ruleService.invalidTickerSymbolField, key: 'tickerSymbolValidation' },
      { value: this.ruleService.invalidNameField, key: 'nameValidation' },
      { value: this.ruleService.specialCharValidationForSedol, key: 'specialCharValidationForSedol' },
      { value: this.ruleService.specialCharValidationForCusip, key: 'specialCharValidationForCusip' },
      { value: this.ruleService.specialCharValidationForIsin, key: 'specialCharValidationForIsin' },
      { value: this.ruleService.invalidCusipSymbolFieldIG, key: 'cusipSymbolValidation' },
      { value: this.ruleService.invalidSedolField, key: 'sedolValidation' },
      { value: this.ruleService.invaliIsinField, key: 'isinValidation' }
    ];

    securityListFilterSubscriptions.forEach(({ value, key }) => {
      value.subscribe(value => {
        this[key] = value;
      });
    });
  }
  toEnableErrorNotifications() {
    const errorMessages = [
      { key: 'tickerSymbolValidation', message: this.getSharedConstant.textFieldErrorMsg.invalidCharacterForGrpOrRuleName },
      { key: 'specialCharValidationForCusip', message: this.getSharedConstant.textFieldErrorMsg.invalidCharacterForGrpOrRuleName },
      { key: 'specialCharValidationForIsin', message: this.getSharedConstant.textFieldErrorMsg.invalidCharacterEnteredAlphaNumericValue },
      { key: 'specialCharValidationForSedol', message: this.getSharedConstant.textFieldErrorMsg.invalidCharacterEnteredAlphaNumericValue },
      { key: 'nameValidation', message: this.getSharedConstant.textFieldErrorMsg.minCharLimitErrorMsg },
      { key: 'cusipSymbolValidation', message: this.getSharedConstant.textFieldErrorMsg.cusipShouldContain9Digits },
      { key: 'sedolValidation', message: this.getSharedConstant.textFieldErrorMsg.sedolShouldContai7Digits },
      { key: 'isinValidation', message: this.getSharedConstant.textFieldErrorMsg.isinShouldContai12Digits }
    ];
    const errMessage = [];
    for (const el of errorMessages) {
      if (this[el.key]) {
        errMessage.push(el.message);
      }
    }
    return errMessage;
  }
  paginate(e) {
    if (this.pageObject.pageNo !== e.page) {
      this.pageObject.pageNo = e.page;
      this.getListOfSecurities();
    }
  }
  getListOfSecurities() {
    const filterValues = {
      parentId: this.modalId,
      ...Object.entries(this.securityListFilterForm.value)
      .reduce((acc, [key, value]) => {
        if (value && !(Array.isArray(value) && value.length === 0)) {
        acc[key === 'securityType' ? 'securityTypeList' : key] =
          key === 'securityType' && Array.isArray(value) ? value?.length === this.getEmtrConstants.instrumentGroups.instrumentGrpStep3.securityTypeList.length ? ['All'] 
          : value.map(item => item.value) : value;
        }
        return acc;
      }, {})
    };
    this.instrumentGroupService.filterIgSecurities(this.pageObject, filterValues).subscribe({
      next: (response: any) => {
        const data = response?.data?.content || [];
        this.tickerSymbolData = data;
        this.totalRecords = this.sharedService.totalElementsWithCommas(response?.data?.totalElements || 0);
        this.paginationCount = response?.data?.totalElements || 0;
        this.filterClicked = this.paginationCount > 1 ? true : false;
        this.customSortCSSRender = this.customSortCss();
        return this.tickerSymbolData;
      }, error: () => {
        this.tickerSymbolData = [];
        this.totalRecords = 0;
        return this.tickerSymbolData;
      }
    });
  }
  customSort(event) {
    if (event.multiSortMeta) {
      const multiSortMetaDup = this.multiSortMeta;
      this.multiSortMeta = event.multiSortMeta;
      const sortArr = this.customSortService.customSort(event);
      if (this.pageObject.sortField !== sortArr) {
        this.isSortingChanged = (JSON.stringify(event.multiSortMeta) === JSON.stringify([this.defaultSortDataField])) ? false : true;
        this.pageObject.pageNo = 0;
        if (this.paginator) {
          this.paginator.changePage(0);
        }
        if ((multiSortMetaDup !== this.multiSortMeta) || multiSortMetaDup.length > 1 || this.sortClearButtonReset) {
          this.pageObject = {
            pageNo: this.pageObject.pageNo,
            pageSize: this.pageObject.pageSize,
            sortField: sortArr
          };
          this.getListOfSecurities();
          this.sortClearButtonReset = false;
        }
      }
    }
  }
  customSortCss(action?) {
    if (action) {
      return action !=='actions' && ((this.paginationCount && this.paginationCount > 1) || this.filterClicked || (this.tickerSymbolData && this.tickerSymbolData.length >1));
    }
    return ((this.paginationCount && this.paginationCount > 1 )|| this.filterClicked || (this.tickerSymbolData && this.tickerSymbolData.length >1)) ? 'pointer-events-auto' : 'pointer-events-none'
  }
  ngOnDestroy() {
    this.ruleService.invalidTickerSymbolField.emit(false);
    this.ruleService.invalidNameField.emit(false);
    this.ruleService.invalidCusipSymbolFieldIG.emit(false);
    this.ruleService.invalidSedolField.emit(false);
    this.ruleService.invaliIsinField.emit(false);
    this.ruleService.specialCharValidationForCusip.emit(false);
    this.ruleService.specialCharValidationForSedol.emit(false);
    this.ruleService.specialCharValidationForIsin.emit(false);
    this.paginationCount = 0;
  }
}
